// extracted by mini-css-extract-plugin
module.exports = {"questionsInfoCardContainer":"styles_questionsInfoCardContainer__3VXnF"};